export default class ConversationReflectionEvent {
    constructor(type, chapterId, conversationId) {
        this._type = type;
        this._chapterId = chapterId;
        this._conversationId = conversationId;
    }

    get type() {
        return this._type;
    }

    get chapterId() {
        return this._chapterId;
    }

    get conversationId() {
        return this._conversationId;
    }
}

ConversationReflectionEvent.COMPLETED = 'ConversationReflectionEvent.COMPLETED';